import * as React from "react";
import { ListItem as OldBulletListItem } from "../../v1";

export function BulletListItem(props) {
  return <OldBulletListItem {...props} version="v2" />;
}
